// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3iPB8","label":"Labeled_label__p3Udx","divider":"Labeled_divider__vS_NN"};